<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Talent Profiles</div>
                <!--button type="button" id='exportUsers' class="btn btn-primary ml-1 pull-right"
                        v-on:click="exportUsersData($event)">
                    Export
                </button-->
                <v-select
                    name="sele_emp"
                    id="sele_emp"
                    @change="changedValue"
                    @input="changedValueUser()"
                    class="col-lg-3 col-sm-12 paddingleft0"
                    :clearable="false"
                    label="text"
                    v-model="sele_emp"
                    :options="usersArr"
                    @search="onSearchUser"
                    :filterable="false"

                    placeholder="Select User"
                    style="background-color: transparent;">
                </v-select>

                <v-select
                    v-model="year"
                    @input="changedValueYear()"
                    name="sele_year"
                    id="sele_year"
                    class="col-lg-1 col-sm-12 paddingleft0"
                    :clearable="false"
                    label="name"
                    :filterable="true"
                    :options="sele_yearArr"
                    placeholder="Select Year"
                    style="background-color: transparent;">
                </v-select>

                <button type="submit" v-on:click.prevent="addTalentProfile" id="add" class="btn btn-primary waves-effect pull-right">Add</button>

            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="app-filter-good-table-container">
                    <!-- List Content Here -->
                    <vue-good-table
                        ref="teamtalentprofile"
                        mode="remote"
                        title="Team Talent Profile"
                        @on-page-change="onPageChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        :totalRows="totalRecords"
                        :columns="columns"
                        :rows="rows"
                        :pagination-options="{
                        enabled: true,
                        mode: 'pages',
                        pageLabel: 'Page',
                        position: 'bottom',
                        perPage: serverParams.perPage,
                        perPageDropdown: [25, 50, 100, 200 ,500],
                        dropdownAllowAll: false,
                        }"
                        :selectOptions="{
                        enabled: true,
                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                        selectionInfoClass: 'custom-class',
                        selectionText: 'rows selected',
                        clearSelectionText: 'clear',
                        }"

                        :search-options="{
                        enabled: false,
                        }">

                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                            <div :key="key">
                                <!--class="btn btn-xs btn-primary"-->
                                <div v-if="props.column.field == 'action'" class="table-action">
                                    <!--router-link title='Edit Profile' class="btn edit-btn-vvg waves-effect" v-bind:to="{name: 'TalentProfile',params:{id:props.row.user.id}}"><i class="fa fa-pencil" aria-hidden="true"></i></router-link-->
                                    <!--router-link title='View Profile' class="btn edit-btn-vvg waves-effect" v-bind:to="{name: 'TalentProfile',params:{id:props.row.user.id, from:''}}"><i class="fa fa-eye" aria-hidden="true"></i></router-link-->
                                    <i class="fa fa-eye btn edit-btn-vvg waves-effect" aria-hidden="true" v-on:click.prevent="viewProfile(props.row.emp_id)"></i>
                                    <!--a title='Delete User' id="delete" class="btn edit-btn-vvg waves-effect"  v-on:click.prevent="deleteSingleUser(props.row.id)"><i class="fa fa-trash" aria-hidden="true"></i></a-->
                                </div>
                                <div v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </div>
                            </div>
                        </template>

                        <!--div slot="selected-row-actions" slot-scope="computed">
                            {{computed.selectedRows}}
                            <button data-toggle="modal" id="changeRoleModel" title='Change role' class="btn btn-primary" data-target="#changeRole" >Change Role</button-->
                            <!--<button data-toggle="modal" id="changeLocationModel" title='Change location' class="btn btn-primary" data-target="#changeLocation" >Change Location</button>-->
                            <!--button id="deleteMultiple" class="btn btn-primary" v-on:click.prevent="changeSelectedUserDetails('deleteMultipleUsres')">Delete Users({{selectedRows}})</button>
                        </div-->

                    </vue-good-table>
                </div>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    import Vue from 'vue'
    import vSelect from 'vue-select';
    import BackendFooter from '@/components/backend/partials/Footer';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    Vue.use(VueGoodTable);
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';
    import VueSweetalert2 from 'vue-sweetalert2';

    Vue.use(VueSweetalert2);

    var self;
    export default {
        name: 'ListBenefits',
        components: {
            'v-select': vSelect,
            'app-backend-footer': BackendFooter
        },
        mixins: [SessioMixin],
        data() {
            return {
                year: '',
                sele_yearArr: [],
                usersArr: [],
                sele_emp: '',
                exportUsers: false,
                filesUser: false,
                filesUserData: [],
                firstLoad: 0,
                roleId: 0,
                roleArr: [],
                locationId: 0,
                locationArr: [],
                columns: [
                    {
                        label: 'First Name',
                        field: 'first_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "First Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Last Name',
                        field: 'last_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Last Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                     {
                        label: 'DayForce Id',
                        field: 'dayforce_id',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "DayForce Id", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                      //                      {
                      //                         label: 'Title',
                      //                         field: 'title',
                      //                         filterable: true,
                      //                         filterOptions: {
                      // //                            placeholder: "MM/DD/YYYY",
                      //                             enabled: true, // enable filter for this column
                      //                             placeholder: "Title", // placeholder for filter input
                      //                             filterValue: '', // initial populated value for this filter
                      //                             filterDropdownItems: [], // dropdown (with selected values) instead of text input
                      //                             filterFn: this.onColumnFilter, //custom filter function that
                      //                             trigger: "enter" //only trigger on enter not on keyup
                      //                         }
                      //                     },
                    {
                        label: 'Role',
                        field: 'role',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Role", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Location',
                        field: 'location',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Location", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    // {
                    //     label: 'Accomplishments',
                    //     field: 'accomplishments',
                    //     filterable: true,
                    //     filterOptions: {
                    //         enabled: true, // enable filter for this column
                    //         placeholder: "Accomplishments", // placeholder for filter input
                    //         filterValue: '', // initial populated value for this filter
                    //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    //         filterFn: this.onColumnFilter, //custom filter function that
                    //         trigger: "enter" //only trigger on enter not on keyup
                    //     }
                    // },
                    // {
                    //     label: 'Opportunities',
                    //     field: 'opportunities',
                    //     filterable: true,
                    //     filterOptions: {
                    //         enabled: true, // enable filter for this column
                    //         placeholder: "Opportunities", // placeholder for filter input
                    //         filterValue: '', // initial populated value for this filter
                    //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    //         filterFn: this.onColumnFilter, //custom filter function that
                    //         trigger: "enter" //only trigger on enter not on keyup
                    //     }
                    // },
                    // {
                    //     label: 'Updated By',
                    //     field: 'updated_by',
                    //     filterable: true,
                    //     filterOptions: {
                    //         enabled: true, // enable filter for this column
                    //         placeholder: "Updated By", // placeholder for filter input
                    //         filterValue: '', // initial populated value for this filter
                    //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    //         filterFn: this.onColumnFilter, //custom filter function that
                    //         trigger: "enter" //only trigger on enter not on keyup
                    //     }
                    // },
                    {
                        label: 'Actions',
                        field: 'action',
                        html: true,
                        sortable: false,
                        thClass: 'disable-sorting',
                    },
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: 'id',
                        type: 'asc',
                    },
                },
                recordsCounts: "",
                selectedRows: 0,
            }

        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
            //self.checkLogin();
        },
        mounted: function () {
            self.showLoader();
            var initial = process.env.ROOT_API;
            initial = initial.replace('/v1', '');
            $("#demourl").attr("href", initial + '/import/ImportEmployeesDemo.xlsx');
//            self = this;
            var dt = new Date();
            self.year = dt.getFullYear();
            $("#add").prop("disabled", true);
            // self.loadTalentProfileUser();
//            self.loadRole();
            // self.loadRoleAdd();
            // self.loadLocationsAdd();
            $("#alertError").hide();
            self.ListOfYears();

        },
        methods:
        {
            ListOfYears: function(){
              var currentYear = new Date().getFullYear(), years = [];
              var startYear = 2000;
              while ( startYear <= currentYear ) {
                  years.push(startYear++);
              }
              self.sele_yearArr = years.reverse();
            },
            changedValueYear: function () {
              console.log(self.year);
              self.loadTalentProfileUser();
              // self.frontendErrors.sele_empError = "";
            },
            onSearchUser(search, loading) {
                let self = this;
                /*if (self.siteid != null && self.siteid != "") {*/
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    self.loadUsers(loading, search, this);
                }
                /*}*/
            },
            loadUsers(loading, search, vm) {
                let self = this;
                var siteId = "";
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };
                var fields = {
                    search: search,
                    except_self : 1,
                    myTeam: 1,
                };
                HTTP.post("getusersdropdown", fields,config)
                    .then(function (response) {
                        console.log(response.data.content);
                        self.usersArr = [];
                        $.each(response.data.content, function (i) {
                            self.usersArr.push(response.data.content[i]);
                        });
                        if (typeof (loading) != "undefined") {
                            loading(false);
                        }
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                self.$router.push("/login");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            },
            changedValue: function (value) {
                //console.log(value);
            },
            changedValueUser: function () {
              if(self.sele_emp != '') {
                $("#add").prop("disabled", false);
              }

                // self.frontendErrors.reportToError = "";
            },
            viewProfile: function(id) {
              console.log(id);
              self.$router.push("/backend/talentprofile?id=" + id + "&from=talentprofile&year=" + self.year);
            },
            changedValue: function (value) {
                //console.log(value);
            },

            onSearchLocation(search, loading) {
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadLocationsAdd(loading, search, this);
                }
            },
            addTalentProfile() {
                // self.$router.push('/backend/addnotregistereduser');
                self.$router.push("/backend/talentprofile?id=" + self.sele_emp.value + "&from=talentprofile&year=" + self.year);
            },

            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            //
            onPageChange(params) {
                self.updateParams({page: params.currentPage});
                self.loadTalentProfileUser();
            },
            //
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({perPage: params.currentPerPage});
                    self.totalRecords = self.totalRecords;
                    self.loadTalentProfileUser();
                }
            },
            selectionChanged() {
                var self = this;
                self.selectedRows = (self.$refs['notregisterUserList'].selectedRows).length;
                /*console.log(self.selectedRows);*/
            },

            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: ('first_name');
                    field: ('last_name');
                    field: ('dayforce_id');
                    field: ('location_name');
                    field: ('role_name');
                    field: ('updated_by');
                }
                ;
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (self.firstLoad == 1 || filters.first_name || filters.last_name || filters.dayforce_id || filters.location_name || filters.role_name || filters.updated_by) {
                    self.loadTalentProfileUser();
                }

            },

            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                self.loadTalentProfileUser();
            },

            loadRoleAdd() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("getroles", '', config)
                        .then(function (response) {
                            /*self.roleArr = response.data.content;*/
                            $.each(response.data.content, function (i) {
                                if (response.data.content[i].value != 0) {
                                    self.roleArr.push(response.data.content[i]);
                                }
                            });
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },

            loadRole(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var data = {
                    search: search
                };
                HTTP.post("getroles", data, config)
                        .then(function (response) {
                            /*self.roleArr = response.data.content;*/
                            $.each(response.data.content, function (i) {
                                if (response.data.content[i].value != 0) {
                                    self.roleArr.push(response.data.content[i]);
                                }
                            });
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },

            changedValueRole: function () {
                self.designationError = "";
            },
            onSearchRole(search, loading) {
                if (search.length >= 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadRole(loading, search, this);
                }
            },

            deleteSingleUser: function (id) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                var fields = {
                    deleteId: id,
                };

                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.showLoader();
                        HTTP.post("changeselectedrole", fields, config)
                                .then(function (response) {
                                    self.loadTalentProfileUser();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                        this.$swal('Deleted', 'You successfully deleted user(s)', 'success');
                    } else {
                        self.$swal('Cancelled', 'Your file is still intact', 'info');
                    }
                })


            },

            changeSelectedUserDetails: function (action) {
                var selectedUser = self.$refs['notregisterUserList'].selectedRows;
                var userArr = [];
                for (var i = 0; i < selectedUser.length; i++) {
                    userArr.push(this.$refs['notregisterUserList'].selectedRows[i].id);
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                switch (action) {
                    case 'change_role' :
                        var fields = {
                            userArr: userArr,
                            roleId: self.roleId.value,

                        };
                        break;

                    case 'change_location' :
                        var fields = {
                            userArr: userArr,
                            locationId: self.locationId,

                        };
                        break;

                    case 'deleteMultipleUsres' :
                        var fields = {
                            deleteIds: userArr,
                        };
                        break;

                }
                if (action == 'deleteMultipleUsres') {
                    this.$swal({
                        title: 'Are you sure?',
                        text: 'You can\'t revert your action',
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Yes Delete it!',
                        cancelButtonText: 'No, Keep it!',
                        showCloseButton: true,
                        showLoaderOnConfirm: true
                    }).then((result) => {
                        if (result.value) {
                            self.showLoader();
                            HTTP.post("changeselectedrole", fields, config)
                                    .then(function (response) {
                                        self.roleId = self.locationId = 0;
                                        self.loadTalentProfileUser();
                                        self.hideLoader();
                                    })
                                    .catch(function (err) {
                                        if (err.response.status == 0) {
                                            self.error = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                self.$router.push("/login");
                                                //EventBus.$emit("logged-in", true, "", "");
                                            }
                                        }
                                        self.hideLoader();
                                    });
                            this.$swal('Deleted', 'You successfully deleted user(s)', 'success')
                        } else {
                            this.$swal('Cancelled', 'Your file is still intact', 'info')
                        }
                    })
                } else if (action == 'change_role' || action == 'change_location') {
                    console.log("in else");
                    self.showLoader();
                    HTTP.post("changeselectedrole", fields, config)
                            .then(function (response) {
                                self.roleId = self.locationId = 0;
                                self.loadTalentProfileUser();
                                if (action == 'change_role') {
                                    self.$swal({
                                        type: 'success',
                                        text: 'Role Changed Successfully',
                                        showConfirmButton: false,
                                        timer: 5000,
                                    });
                                }
                                if (action == 'change_location') {
                                    self.$swal({
                                        type: 'success',
                                        text: 'Location Changed Successfully',
                                        showConfirmButton: false,
                                        timer: 5000,
                                    });
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                }
                                self.hideLoader();
                            });
                }

            },

            loadLocationsAdd(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var data = {
                    search: search
                };
                HTTP.post("getlocation", data)
                        .then(function (response) {
                            /*self.locationArr = response.data.content;*/
                            $.each(response.data.content, function (i) {
                                if (response.data.content[i].value != 0) {
                                    self.locationArr.push(response.data.content[i]);
                                }
                            });
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },

            loadTalentProfileUser: function () {
                self.firstLoad = 1;
                var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage)
                if (newPage) {
                    if (newPage < self.serverParams.page) {
                        self.serverParams.page = newPage;
                    }
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    messageData: self.message,
                    sort: self.serverParams.sort,
                    year: self.year
                };
                self.showLoader();
                HTTP.post('talent/profile/team',fields, config)
                        .then(function (response) {
                            $('#exportUsers').text('Export');
                            $('#exportUsers').prop("disabled", false);
                            if (response.data.message == "success export") {
                                location.href = response.data.content.web;
                            } else if (response.data.code == '200') {
                                self.rows = response.data.content.row;
                                self.totalRecords = response.data.content.totalRecords;
                            }
                            self.exportUsers = false;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            $('#exportUsers').text('Export');
                            $('#exportUsers').prop("disabled", false);
                            if (err.response.status == 0) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                    self.error = err.response.data.message;
                                }
                            }
                            self.exportUsers = false;
                            self.hideLoader();
                        })
            },
            exportUsersData: function () {
                self.showLoader();
                self.exportUsers = true;
                if (self.exportUsers == true) {
                    $('#exportUsers').text('Exporting...');
                    $('#exportUsers').prop("disabled", true);
                    self.loadTalentProfileUser();
                }
                self.hideLoader();
            },
            hideModelCall() {
                $('#newUserImportModal').modal('hide');
                return false;
            },
            importUsersData(e) {
                $(e.target).text('Importing...');
                $(e.target).prop("disabled", true);
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var fields = new FormData();
                for (var i = 0; i < self.filesUserData.length; i++) {
                    let file = self.filesUserData[0];
                    //console.log(file);
                    fields.append('excl_file', file);
                }
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You want to import users?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes import it!',
                    cancelButtonText: 'No, Don\'t import it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.showLoader();
                        HTTP.post('importusers', fields, config)
                                .then(function (response) {
                                    $(e.target).text('Import');
                                    $(e.target).prop("disabled", false);
                                    if (response.data.code == '200') {
                                        self.filesUserData = [];
                                        $('#upload').val('');
                                        $('#newUserImportModal').modal('hide');
                                        self.$swal({
                                            type: 'success',
                                            text: 'Users Imported Successfully',
                                            showConfirmButton: false,
                                            timer: 5000,
                                        });
                                        self.loadTalentProfileUser();
                                    } else {
                                        $("#alertError").show();
                                        console.log(response.data.content);
                                        $("#backErrorMsg").html(response.data.content);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }
                                    self.hideLoader();
                                })
                                .catch(function (err) {
                                    $(e.target).text('Import');
                                    $(e.target).prop("disabled", false);
                                    //$('#queueEmail').modal('hide');
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        } else {
                                            $("#alertError").show();
                                            $("#backErrorMsg").html(err.response.data.content);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                    self.hideLoader();
                                });
                    } else {
                        self.$swal('Cancelled', 'Your have canceled import users', 'info')
                        $(e.target).text('Import');
                        $(e.target).prop("disabled", false);
                        self.filesUserData = [];
                        $('#upload').val('');
                        $('#newUserImportModal').modal('hide');
                    }
                });
            },
            handleFilesUploadCall: function () {
                let uploadedFiles = "";
                uploadedFiles = self.$refs.filesUserData.files;

                for (var i = 0; i < uploadedFiles.length; i++) {
                    self.filesUserData = [uploadedFiles[i]];
                }
                /*this.getImagePreviews();*/
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/talentprofile/ListTalentProfile.vue